/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Remove',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M5.60019 11.4C5.26882 11.4 5.00019 11.6686 5.00019 12C5.00019 12.3314 5.26882 12.6 5.60019 12.6H18.4002C18.7316 12.6 19.0002 12.3314 19.0002 12C19.0002 11.6686 18.7316 11.4 18.4002 11.4H5.60019Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0002 1C5.93305 1 1.00018 5.93286 1.00018 12C1.00018 18.0671 5.93305 23 12.0002 23C18.0673 23 23.0002 18.0671 23.0002 12C23.0002 5.93286 18.0673 1 12.0002 1ZM2.20018 12C2.20018 6.5956 6.59579 2.2 12.0002 2.2C17.4046 2.2 21.8002 6.5956 21.8002 12C21.8002 17.4044 17.4046 21.8 12.0002 21.8C6.59579 21.8 2.20018 17.4044 2.20018 12Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
